import React from "react"; import Navbar from './navBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/md-dark-indigo/theme.css";
import "primereact/resources/primereact.min.css"
import 'primeicons/primeicons.css';
import 'react-slideshow-image/dist/styles.css'
import "../style/aboutPage.css";
import { useTranslation } from "react-i18next";
import FooterComponent from "./footer";

const AboutPage = () => {
    const { t, i18n } = useTranslation();
    return (
        <PrimeReactProvider>
            <Navbar />
            <div className="AboutPage">
                <h1 style={{ fontWeight: "bold" }}>{t('about')}</h1>
                <div className="aboutBackground">
                    <p>{t("aboutContent")}</p>
                </div>
            </div>
            <FooterComponent />
        </PrimeReactProvider>
    );
}
export default AboutPage;